// extracted by mini-css-extract-plugin
export default {"content":"style_content__CqRkq","padding":"style_padding__okT0D","padding2":"style_padding2__CmsCP","none":"style_none__hWnjd","btn-submit":"style_btn-submit__7xPAH"};